import { rem } from 'polished';
import { layoutTheme } from '@luigiclaudio/ga-baseline-ui/layout';
import { baseTheme } from '@luigiclaudio/ga-baseline-ui/base-theme';
import siteTheme from './siteTheme';
import 'fontsource-catamaran';
import 'fontsource-roboto-condensed';

const theme = {
    breakpoints: [
        `${rem(layoutTheme.layout.media.xxs)}`,
        `${rem(layoutTheme.layout.media.xs)}`,
        `${rem(layoutTheme.layout.media.sm)}`,
        `${rem(layoutTheme.layout.media.md)}`,
        `${rem(layoutTheme.layout.media.lg)}`,
        `${rem(layoutTheme.layout.media.xl)}`,
    ],
    typography: {
        base: {
            fontFamily: 'Catamaran, sans-serif',
            fontSizeMin: 16,
        },
        headings: {
            fontFamily: 'Catamaran, sans-serif',
        },
    },
    footer: {
        defaultFooter: {
            backgroundStart: '#f4f4f4',
            backgroundEnd: '#f4f4f4',
        },
    },
    button: {
        borderRadius: {
            default: 32,
        },
    },
    commerce: {
        adsBanner: {
            fontFamily: '"Roboto Condensed", sans-serif',
        },
    },
    ...baseTheme,
    ...siteTheme,
};

export default theme;
